// @flow

import * as React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import ProductLockup from "@components/molecules/ProductLockup";

type PropsType = {
    cms: any
};

const LimitedTimeOnly = (props: PropsType): React.Node => {
    const products = _.filter(_.get(props, "cms.limitedTimeProducts", []), {
        delivery: true
    });

    if (products && products.length) {
        return (
            <section className="landing-page-section landing-page-section--limited-time">
                <div className="container-fluid">
                    <h2 className="landing-page-section__title heading-2">
                        Limited Time Only
                    </h2>
                    <ProductLockup type="limited" items={products} />
                </div>
            </section>
        );
    } else {
        return null;
    }
};

const mapStateToProps = (state: any): any => ({
    cms: state.cms
});

export default connect(mapStateToProps)(LimitedTimeOnly);
